import PrivateAdminRouteComponent from './PrivateAdminRouteComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getIsLoggedIn,
  hasAccountsUsersAndGroupsPermission
} from 'actions/auth/login';
import { withRouter } from 'react-router';

// Connect the STATE to the props fed into the component.
export const mapStateToProps = (state) => ({
  isLoggedIn: getIsLoggedIn(state),
  hasAccountsPermission: hasAccountsUsersAndGroupsPermission(state)
});

// Connect ACTIONS to the props fed into the component.
export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

// Create higher-order component which feeds in specified props.
const PrivateAdminRouteContainer = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PrivateAdminRouteComponent)
);

export default PrivateAdminRouteContainer;



// WEBPACK FOOTER //
// ./src/components/common/PrivateAdminRoute/PrivateAdminRouteContainer.js